import { useQuery } from "@tanstack/react-query";
import { OfferService } from "@/generated/services/OfferService";
import { offer } from "@/generated";

export function useFetchOffer(
  offerId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ["offer", offerId],
    queryFn: async () => {
      const response = await OfferService.getOffers1(
        Number(offerId),
        undefined,
        Number(process.env.NEXT_PUBLIC_RETAILER_ID) || 0,
      );
      return response as unknown as offer;
    },
    enabled: options?.enabled !== false && !!offerId,
    gcTime: 0, // Don't cache the response
    staleTime: 0, // Always consider data stale to refetch
  });
}
